// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__3MoXR","title":"contact_title__b6brp","inputs":"contact_inputs__Oxevp"};